import type { InternalIdentity } from 'src/interfaces/internalAuth'
import type { State } from '../reducers/types'

export const getInternalIdentity = (state: State): InternalIdentity | null => {
  return state.internalAuth.identity
}

export const getInternalAuthLoading = (state: State): boolean => {
  return state.internalAuth.isLoading
}

export const getInternalAuthError = (state: State): string | null => {
  return state.internalAuth.error
}
